import LibraryService from "@/services/LibraryService";

const state = {
  books: [],
  reportCards: [],
  studentReportCard: null,
};

const getters = {
  getBooks(state) {
    return state.books;
  },
  getReportCards(state) {
    return state.reportCards.map((reportCard) => {
      reportCard.flex = 4;
      return reportCard;
    });
  },
  getStudentReportCard(state) {
    return state.studentReportCard;
  },
};

const actions = {
  async loadBooks({ commit }) {
    const response = await LibraryService.getBooks();
    const books = response.data.results || [];

    commit("setBooks", books);
  },
  async loadReportCard({ commit, rootGetters }) {
    const serverUrl = rootGetters["ConfigStore/getServerUrl"];
    const response = await LibraryService.geReportCard();
    const rawReportCards = response.data.results || [];

    const reportCards = rawReportCards.map((reportCard) => {
      const url = new URL(reportCard.link, serverUrl);
      reportCard.link = url.href;
      const fileName = url.pathname.split("/").pop();
      reportCard.fileName = fileName;
      return reportCard;
    });
    commit("setReportCards", reportCards);
  },
  async loadStudentReportCard({ commit }) {
    const response = await LibraryService.getStudentReportCardPreview();
    commit("setStudentReportCard", response.data);
    return response.data;
  },
  downloadStudentReportCard() {
    return LibraryService.getStudentReportCardPdf();
  },
};

const mutations = {
  setBooks(state, books) {
    state.books = books;
  },
  setReportCards(state, val) {
    state.reportCards = val;
  },
  setStudentReportCard(state, reportCard) {
    state.studentReportCard = reportCard;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
